import { useContext, useEffect } from 'react'
import { UGEContext } from '../context'
import { UGEEditor as IUGEEditor } from '../types'
import Captions from './captions'
import Crop from './crop'
import Default from './default'
import Filters from './filters'
import Layers from './layers'
import Stickers from './stickers'
import { Container } from './style'

type Props = {
    className?: string
}

function getEditorComponent(activeEditor: IUGEEditor) {
    switch (activeEditor) {
        case 'captions':
            return Captions
        case 'crop':
            return Crop
        case 'filters':
            return Filters
        case 'layers':
            return Layers
        case 'stickers':
            return Stickers
        default:
            return Default
    }
}

const UGEEditor = ({ className }: Props) => {
    const { activeEditor, activeEditorProps, loaded, trackGAEvent } = useContext(UGEContext)
    const Editor = getEditorComponent(activeEditor)

    useEffect(() => {
        switch (activeEditor) {
            case 'captions':
                trackGAEvent('creation_caption_open')
                break
            case 'crop':
                trackGAEvent('crop_content_open')
                break
            case 'default':
                trackGAEvent('edit_landing_open')
                break
            case 'filters':
                trackGAEvent('creation_filter_open')
                break
            case 'layers':
                trackGAEvent('layer_menu_open')
                break
            case 'stickers':
                trackGAEvent('creation_asset_open', {
                    creation: {
                        quickDecorateTerm: activeEditorProps?.searchTerm,
                    },
                })
                break
        }
    }, [activeEditor])

    if (!loaded) {
        return null
    }

    return (
        <Container className={className}>
            <Editor />
        </Container>
    )
}

export default UGEEditor
